export enum StepEnum {
    RegisterType, PartnerBrokerage, PersonalInformation, Address, Password, FinalLoading
  }
  export enum ProgressBarMaxEnum {
    Personal = 10, Broker = 5, MercBitcoin = 11
  }
  export enum TypeRegistration {
    Personal = 1, Provider = 2 
  }